import { Fragment, useState } from 'react';
import { Trans } from '@lingui/macro';
import { AvatarWithLabel, Button, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { usePlaiDrawer } from 'app/domains/documents';
import { PlaybookReference } from './PlaybookReference';
import { Resolve } from './Resolve';
import { Sources } from './Sources';
import { getAvatarAppearance } from './utils';
import { Actions, Container, Description, ExpandButton, Spacer, StyledListItem } from './styled';
export function Feedback(props) {
    const [open, setOpen] = useState(false);
    const { feedback: { id, name, criticality, content }, playbookRules, } = props;
    const { onSelectFeedback } = usePlaiDrawer();
    const [expanded, setExpanded] = useState(false);
    const handleToggle = () => setOpen(!open);
    const handleExpand = () => setExpanded(!expanded);
    return (<div>
      <StyledListItem onClick={handleToggle} $selected={open}>
        <AvatarWithLabel solid shape="circle" size="md" appearance={getAvatarAppearance(criticality)} title={name}>
          <Falcon icon="exclamation-circle"/>
        </AvatarWithLabel>
        <IconButton appearance="ghost" onClick={handleToggle}>
          {open ? <Falcon icon="chevron-up"/> : <Falcon icon="chevron-down"/>}
        </IconButton>
      </StyledListItem>
      {open && (<Container>
          <Description $appearance="300" $fontSize="medium" $expanded={expanded}>
            {content}
          </Description>
          <ExpandButton appearance="ghost" size="small" onClick={handleExpand}>
            {expanded ? (<Fragment>
                <Trans comment="Plai review - issue description - button to collapse the description - label">
                  Collapse description
                </Trans>
                <Falcon icon="chevron-up"/>
              </Fragment>) : (<Fragment>
                <Trans comment="Plai review - issue description - button to expand the description - label">
                  Full description
                </Trans>
                <Falcon icon="chevron-down"/>
              </Fragment>)}
          </ExpandButton>
          <Actions>
            <Spacer>
              <Button onClick={() => onSelectFeedback(id)}>
                <Falcon icon="comment"/>
                <Trans comment="Plai Review - Issue description - follow up button - label">
                  Follow-up
                </Trans>
              </Button>
              <Resolve />
            </Spacer>
            <Spacer>
              <PlaybookReference playbookRules={playbookRules}/>
            </Spacer>
          </Actions>
          <Sources feedbackId={id}/>
        </Container>)}
    </div>);
}
